// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__21kfX","notes":"Notes_notes__7uMZr"};